// src/components/ProductListItem.jsx

import { Link } from 'react-router-dom';

function ProductListItem({ product, isOpen, onToggle }) {
  const nutritionData = [
    { name: 'Energy', value: 61.98, unit: 'Kcal', icon: '⚡' },
    { name: 'Carbs', value: 15.49, unit: 'g', icon: '🌾' },
    { name: 'Sugar', value: 15.33, unit: 'g', icon: '🍬' },
    { name: 'Sodium', value: 109.34, unit: 'mg', icon: '🧂' },
  ];

  return (
    <div className="product-list-item">
      <div className="product-list-header" onClick={onToggle}>
        <div className="product-list-name-with-info">
          <span className="product-list-name">{product.name}</span>
          <div className="nutrition-info-tooltip">
            <i className="fas fa-info-circle"></i>
            <div className="nutrition-tooltip-content">
              <div className="tooltip-header">Nutrition Facts (Per 100ml)</div>
              {nutritionData.map((nutrient, index) => (
                <div key={index} className="tooltip-nutrient">
                  <span className="tooltip-icon">{nutrient.icon}</span>
                  <span className="tooltip-name">{nutrient.name}:</span>
                  <span className="tooltip-value">{nutrient.value} {nutrient.unit}</span>
                </div>
              ))}
              <div className="tooltip-footer">
                <div>⚡ Contains Caffeine</div>
                <div>🍋 7% Lemon Juice</div>
              </div>
            </div>
          </div>
        </div>
        <i className={`fas fa-chevron-down toggle-icon ${isOpen ? 'open' : ''}`}></i>
      </div>

      <div className={`product-list-details ${isOpen ? 'open' : ''}`}>
        <div className="product-list-image-container">
          <img src={product.image} alt={product.name} className="product-list-image" />
        </div>
        <p className="product-list-desc">{product.description}</p>
        <div className="product-list-footer">
          <span className="product-price">{product.price}</span>
          <a
            href="https://www.instagram.com/torque_it_is?igsh=MWY5azkyYXE2dG81ZA=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="contact-btn">Contact Us</button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProductListItem;